import { z } from 'zod'

import { CMMS_RECORD_TYPES } from './cmmsRecordTypes'

export const CmmsDocumentNodeSchema = z.object({
  id: z.string(),
  source_path: z.string(),
  label: z.string(),
  kind: z.enum(['text', 'paragraph', 'date', 'money', 'quantity', 'code']),
  value: z.string(),
  currency: z
    .string()
    .regex(/^[A-Z]{3}$/)
    .nullable(),
  unit: z.string().nullable(),
  semantic: z.boolean(),
})

export const CmmsDocumentSchema = z.object({
  schema_version: z.literal(1),
  compiler_version: z.string(),
  revision: z.string().min(1),
  entry_id: z.string(),
  entry_type: z.enum(CMMS_RECORD_TYPES),
  source_version: z.string(),
  kind: z.string(),
  number: z.string(),
  title: z.string(),
  interpretation: z.string(),
  search_fields: z.record(
    z.string(),
    z.union([z.string(), z.number(), z.null()])
  ),
  header: z.object({
    title_node_id: z.string().nullable(),
    number_node_id: z.string().nullable(),
    status_node_id: z.string().nullable(),
    status_label_node_id: z.string().nullable(),
  }),
  sections: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      nodes: z.array(CmmsDocumentNodeSchema),
    })
  ),
  evidence: z.object({
    text: z.string(),
    spans: z.array(
      z.object({
        node_id: z.string(),
        start: z.number().int().nonnegative(),
        end: z.number().int().nonnegative(),
      })
    ),
  }),
})

export type CmmsDocumentNode = z.infer<typeof CmmsDocumentNodeSchema>
